/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Jpc_Date_ValInputs */

const es_cap_jpc_date_val = /** @type {(inputs: Cap_Jpc_Date_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sáb 14 jun · 10:00`)
};

const gl_cap_jpc_date_val = /** @type {(inputs: Cap_Jpc_Date_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sáb 14 xuñ · 10:00`)
};

const en_cap_jpc_date_val = /** @type {(inputs: Cap_Jpc_Date_ValInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sat 14 Jun · 10:00`)
};

/**
* | output |
* | --- |
* | "Sat 14 Jun · 10:00" |
*
* @param {Cap_Jpc_Date_ValInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_jpc_date_val = /** @type {((inputs?: Cap_Jpc_Date_ValInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Jpc_Date_ValInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_jpc_date_val(inputs)
	if (locale === "en") return en_cap_jpc_date_val(inputs)
	return es_cap_jpc_date_val(inputs)
});